/*
 * custom-product.js
 * ELLIZ CLOSET — custom product page behaviour (mobile).
 *
 * Extracted from inline <script> blocks that previously lived inside
 * templates/product.json. Consolidates:
 *   - the mobile experience IIFE (back button, gallery numeric nav,
 *     mobile variant tabs) from the "TITLE" custom_liquid block, and
 *   - buildDividers(), which was copy-pasted into 6 separate
 *     "divider mobile" custom_liquid blocks. It is now a single
 *     function that processes every .cmb-divider-anchor on the page.
 *
 * No behaviour change. Loaded once with defer from the product template.
 */
(function () {
  'use strict';

  var MOBILE_MAX  = 767;
  var INIT_PASSES = [0, 200, 600, 1200, 2000];
  var variantBuilt = false;

  function isMobile() { return window.innerWidth <= MOBILE_MAX; }

  function qs(root, sel) {
    if (!root || !sel) return null;
    try { return root.querySelector(sel); } catch(e) { return null; }
  }
  function qsa(root, sel) {
    if (!root || !sel) return [];
    try { var nl = root.querySelectorAll(sel), a = []; for (var i=0;i<nl.length;i++) a.push(nl[i]); return a; }
    catch(e) { return []; }
  }

  function syncHtmlClass() {
    document.documentElement.classList.toggle('cmb-mobile', isMobile());
  }

  /* ── Section dividers (was buildDividers x6) ── */
  function buildDividers() {
    if (window.innerWidth > MOBILE_MAX) return;
    var anchors = document.querySelectorAll('.cmb-divider-anchor');
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      if (anchor.getAttribute('data-cmb-built') === 'true') continue;
      anchor.setAttribute('data-cmb-built', 'true');

      var hr = document.createElement('div');
      hr.className = 'cmb-divider';
      var h = anchor.getAttribute('data-divider-height');
      hr.style.height = (h ? h : '12') + 'px';

      anchor.parentNode.insertBefore(hr, anchor.nextSibling);
    }
  }

  /* ── Back button ── */
  function handleBack() {
    if (window.history.length > 1) window.history.back();
    else if (document.referrer) window.location.href = document.referrer;
    else window.location.href = '/';
  }
  function ensureBackButton() {
    if (!document.body || document.getElementById('cmb-back-btn')) return;
    var btn = document.createElement('button');
    btn.id = 'cmb-back-btn'; btn.className = 'cmb-back'; btn.type = 'button';
    btn.setAttribute('aria-label', 'Go back');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<line class="arr-outline" x1="21" y1="12" x2="5" y2="12"></line>' +
        '<polyline class="arr-outline" points="11 6 5 12 11 18"></polyline>' +
        '<line class="arr-fill" x1="21" y1="12" x2="5" y2="12"></line>' +
        '<polyline class="arr-fill" points="11 6 5 12 11 18"></polyline>' +
      '</svg>';
    btn.addEventListener('click', handleBack);
    document.body.appendChild(btn);
  }

  /* ── Variant UI — disabled on ELLIZ PDP (native Wokiee picker only) ── */
  function buildVariantUI() {
    if (document.body.classList.contains('template-product')) return;
    if (!isMobile() || variantBuilt) return;

    var section = qs(document, '[data-section-name="main-product"]');
    if (!section) return;

    var allFieldsets = qsa(section,
      'fieldset.product-form__input, fieldset[class*="variant"], fieldset[id*="option"]'
    );

    var seenLegend = {};
    var uniqueFieldsets = [];
    for (var fi = 0; fi < allFieldsets.length; fi++) {
      var lg = qs(allFieldsets[fi], 'legend');
      var lgText = lg ? (lg.textContent || lg.innerText || '').trim() : ('__f' + fi);
      var lgKey = lgText.split(':')[0].trim().toLowerCase();
      if (!seenLegend[lgKey]) {
        seenLegend[lgKey] = true;
        uniqueFieldsets.push({ el: allFieldsets[fi], label: lgText.split(':')[0].trim() });
      }
    }

    if (!uniqueFieldsets.length) {
      var selects = qsa(section,
        'select[name*="option"], select[data-index], select[id*="option"]'
      );
      var seenSel = {};
      for (var si = 0; si < selects.length; si++) {
        var selId = selects[si].name || selects[si].id || ('__s' + si);
        if (!seenSel[selId]) {
          seenSel[selId] = true;
          uniqueFieldsets.push({ el: null, selectEl: selects[si], label: selId, optionIndex: si });
        }
      }
    }

    if (!uniqueFieldsets.length) {
      setTimeout(buildVariantUI, 500);
      return;
    }

    var productInfo = qs(section,
      '.product__column__content, .product-information, .product-info, ' +
      '.product__info-wrapper, .tt-product-single-info'
    );
    if (!productInfo) return;

    var buyBlock = qs(productInfo,
      '.product__buttons, .product-form__buttons, .product__buy-buttons, ' +
      '[class*="buy-button"], .shopify-payment-button, button[name="add"], ' +
      '.btn-product-add-cart, .tt-btn-addtocart, .product-form__submit, ' +
      '[class*="add-to-cart"], .product-form'
    );
    var insertBefore = null;
    if (buyBlock) {
      var node = buyBlock;
      while (node && node.parentNode !== productInfo) node = node.parentNode;
      if (node && node.parentNode === productInfo) insertBefore = node;
    }

    var old = document.getElementById('cmb-variant-root');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var root = document.createElement('div');
    root.id = 'cmb-variant-root';

    for (var ufi = 0; ufi < uniqueFieldsets.length; ufi++) {
      (function(uf) {
        var uiWrap = document.createElement('div');
        uiWrap.className = 'cmb-variant-ui';

        var labelEl = document.createElement('div');
        labelEl.className = 'cmb-variant-label';
        labelEl.textContent = uf.label;
        uiWrap.appendChild(labelEl);

        var optRow = document.createElement('div');
        optRow.className = 'cmb-variant-options';

        if (uf.el) {
          var allRadios = qsa(uf.el, 'input[type="radio"]');
          var seenVal = {}, uniqueRadios = [];
          for (var ri = 0; ri < allRadios.length; ri++) {
            var v = allRadios[ri].value;
            if (!seenVal[v]) { seenVal[v] = true; uniqueRadios.push(allRadios[ri]); }
          }
          for (var ui2 = 0; ui2 < uniqueRadios.length; ui2++) {
            (function(radio) {
              var lbl = qs(uf.el, 'label[for="' + radio.id + '"]');
              var txt = radio.value;
              if (lbl) {
                var childNodes = lbl.childNodes;
                for (var cn = 0; cn < childNodes.length; cn++) {
                  if (childNodes[cn].nodeType === 3) {
                    var t = childNodes[cn].nodeValue.trim();
                    if (t) { txt = t; break; }
                  }
                }
              }
              var isUnavail = radio.disabled ||
                !!(lbl && (lbl.classList.contains('disabled') || lbl.classList.contains('sold-out'))) ||
                !!(radio.closest && (radio.closest('[class*="sold-out"]') || radio.closest('.disabled')));

              var btn = document.createElement('button');
              btn.type = 'button'; btn.textContent = txt;
              if (isUnavail) btn.classList.add('is-unavailable');
              if (radio.checked) btn.classList.add('is-selected');
              btn.addEventListener('click', function() {
                if (btn.classList.contains('is-unavailable')) return;
                qsa(optRow, 'button').forEach(function(b){ b.classList.remove('is-selected'); });
                btn.classList.add('is-selected');
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
                radio.dispatchEvent(new Event('input',  { bubbles: true }));
              });
              optRow.appendChild(btn);
            })(uniqueRadios[ui2]);
          }
        }

        if (uf.selectEl) {
          var sel = uf.selectEl;
          var opts = sel.options;
          for (var oi = 0; oi < opts.length; oi++) {
            (function(opt) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.textContent = opt.text.trim();
              if (opt.disabled) btn.classList.add('is-unavailable');
              if (opt.selected) btn.classList.add('is-selected');
              btn.addEventListener('click', function() {
                if (btn.classList.contains('is-unavailable')) return;
                qsa(optRow, 'button').forEach(function(b){ b.classList.remove('is-selected'); });
                btn.classList.add('is-selected');
                sel.value = opt.value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
              });
              optRow.appendChild(btn);
            })(opts[oi]);
          }
        }

        if (qsa(optRow, 'button').length > 0) {
          uiWrap.appendChild(optRow);
          root.appendChild(uiWrap);
        }
      })(uniqueFieldsets[ufi]);
    }

    if (!root.children.length) {
      setTimeout(buildVariantUI, 500);
      return;
    }

    if (insertBefore) {
      productInfo.insertBefore(root, insertBefore);
    } else {
      var first = productInfo.firstElementChild;
      if (first) productInfo.insertBefore(root, first.nextSibling);
      else productInfo.appendChild(root);
    }

    variantBuilt = true;
  }

  /* ── Mobile chrome: html flag + back button.
       Gallery pagination is handled by Wokiee's native swiper dots
       (media_type_mobile: "dots"); no custom numeric overlay. ── */
  function initGallery() {
    syncHtmlClass();
    ensureBackButton();
  }

  function scheduleAllPasses() {
    variantBuilt = false;
    for (var i = 0; i < INIT_PASSES.length; i++) {
      (function(delay){
        setTimeout(function(){ initGallery(); buildVariantUI(); buildDividers(); }, delay);
      })(INIT_PASSES[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', scheduleAllPasses);
  window.addEventListener('load', scheduleAllPasses);

  window.addEventListener('resize', function() {
    syncHtmlClass(); ensureBackButton();
    if (isMobile()) {
      initGallery();
      if (!variantBuilt) buildVariantUI();
      buildDividers();
    } else {
      variantBuilt = false;
      var vRoot = document.getElementById('cmb-variant-root');
      if (vRoot && vRoot.parentNode) vRoot.parentNode.removeChild(vRoot);
    }
  });

  document.addEventListener('shopify:section:load', scheduleAllPasses);

  function attachBodyObserver() {
    if (!document.body) return;
    new MutationObserver(function(){ ensureBackButton(); })
      .observe(document.body, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachBodyObserver);
  else attachBodyObserver();

  syncHtmlClass();
})();
